import React from 'react';
import styled from 'styled-components';
import { CloseIcon } from '../icons/CloseIcon';

const StyledFixedForm = styled.div`
    position: fixed;
    height: 100%;
    padding-top: 64px;
    bottom: 0;
    left: ${({ left }) => left && 0};
    right: ${({ right }) => right && 0};
    z-index: 1;
    box-shadow: -2px 0px 16px rgba(116, 151, 208, 0.1);
    transition: .3s ease;
    animation: toast-in-right .7s;

    @keyframes toast-in-right {
        from {
            transform: translateX(100%);
        }
        to {
            transform: translateX(0);
        }
    }
`;

const CloseFormButton = styled.span`
    position: fixed;
    top: 84px;
    right: 20px;
`;

const StyledPanelContent = styled.div`
    display: flex;
    flex-direction: column;
    height: 100%;
    width: ${({width}) => width ? width : 500}px;
    padding: 22px 12px 32px 32px;
    background: #FFFFFF;
`;

export const FixedForm = ({ onClose, ...props}) => (
    <StyledFixedForm right { ...props }>
        <CloseFormButton onClick={() => onClose()}>
            <CloseIcon/>
        </CloseFormButton>
        <StyledPanelContent {...props}>
            {props.children}
        </StyledPanelContent>
    </StyledFixedForm>
);